import type {
  AxisStructuredDataIndustry,
  AxisStructuredDataInquiryType,
  AxisStructuredDataSubIndustry,
  AxisStructuredDataTypeEnum,
} from '../../../gql/graphql';

export interface AxisStructuredDataInput {
  inquiryType?: AxisStructuredDataInquiryType | null;
  type?: AxisStructuredDataTypeEnum | null;
  industry?: AxisStructuredDataIndustry | null;
  subIndustry?: AxisStructuredDataSubIndustry | null;
}

export class AxisStructuredData {
  inquiryType?: AxisStructuredDataInquiryType | null;
  type?: AxisStructuredDataTypeEnum | null;
  industry?: AxisStructuredDataIndustry | null;
  subIndustry?: AxisStructuredDataSubIndustry | null;

  constructor(input: AxisStructuredDataInput) {
    this.inquiryType = input.inquiryType;
    this.type = input.type;
    this.industry = input.industry;
    this.subIndustry = input.subIndustry;
  }

  hasDisplayFields(): boolean {
    return Boolean(this.type || this.industry || this.subIndustry);
  }

  static generateFromBackendResponse(
    response: AxisStructuredDataInput | null | undefined,
  ): AxisStructuredData | null {
    if (!response) {
      return null;
    }

    const structuredData = new AxisStructuredData(response);
    return structuredData.hasDisplayFields() ||
      structuredData.inquiryType
      ? structuredData
      : null;
  }
}
